import React from 'react'


import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import CampoAddizionalePrezzo from './CampoAddizionalePrezzo';

const {logger} = useBSSLogger();

const FormAddizionaliPrezzo = ({listaaddizionali, prodotto, preventivo, eseguiRicalcolo}) => {        
    
    return (
        <>
            {listaaddizionali.map((addizionale, indiceAddizionale) => {                                                                                                                

                return (
                    <CampoAddizionalePrezzo key={indiceAddizionale} {...{addizionale, prodotto, preventivo, eseguiRicalcolo}} />                       
                )
            })}
        </>
    )
}

export default FormAddizionaliPrezzo;